"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevDbMapper = void 0;
const mapper_1 = require("./mapper");
class DevDbMapper {
    static mapBrands(data) {
        return mapper_1.PdaMapper.mapList(data, this.BrandSchema);
    }
    static mapDevices(data) {
        // Data input is the 'rest' array: [CatSlug, CatName, BrandSlug, BrandName, DevicesList]
        if (!Array.isArray(data) || data.length < 5)
            return { catalog: {}, brand: {}, devices: [] };
        const catalog = { id: data[0], title: data[1] };
        const brand = { slug: data[2], name: data[3] };
        const devices = mapper_1.PdaMapper.mapList(data[4], this.DevicePreviewSchema);
        return { catalog, brand, devices };
    }
    static mapDeviceDetail(data) {
        return mapper_1.PdaMapper.map(data, this.DeviceDetailSchema);
    }
}
exports.DevDbMapper = DevDbMapper;
DevDbMapper.BrandSchema = {
    slug: 0,
    name: 1,
    devicesCount: 2,
    newDevicesCount: 3
};
DevDbMapper.SpecSchema = {
    type: 0,
    key: 1,
    label: 2,
    value: 3,
    displayValue: 4
};
DevDbMapper.DevicePreviewSchema = {
    slug: 0,
    name: 1,
    imageUrl: 2,
    flag: 3,
    specs: { index: 4, list: DevDbMapper.SpecSchema }
};
DevDbMapper.ImageSchema = {
    type: 0,
    url: 2, // Index 1 is often same as 2? or full/thumb?
    // Log: [1, "full_url.jpg", "thumb_url.jpg"] (Wait, user log: [1, "url.p.jpg", "url.n.jpg"])
    // My check log: [1, "...p.jpg", "...n.jpg"]
    // Often 4pda uses [Type, Preview, Full] or [Type, Full, Preview]
    // Let's assume index 2 is full/larger?
    // User log: [1, "https...p.jpg", "https...n.jpg"] -> p is usually preview, n is neutral/full?
    // Actually 'p' is usually preview, 'n' might be normal?
    // Let's map 1 to thumbnail and 2 to full/url?
    // Log: [1, "url...p.jpg?_=0", "url...n.jpg?_=0"]
    // Let's map url=2, thumbnailUrl=1
    thumbnailUrl: 1
};
DevDbMapper.DeviceDetailSchema = {
    category: {
        index: [0, 1],
        map: (v) => ({ id: v[0], title: v[1] })
    },
    brand: {
        index: [2, 3],
        map: (v) => ({ slug: v[0], name: v[1] })
    },
    modelName: 4,
    variantName: 5,
    variants: 6, // List of {slug, name}? Keep raw for now or map if we know structure
    images: { index: 7, list: DevDbMapper.ImageSchema },
    specs: { index: 8, list: DevDbMapper.SpecSchema },
    isInMyDevices: { index: 9, map: (v) => !!v }
};
